import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getGeminiCliInstructions = (playground, bearerToken, mcpServerUrl) => {
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  let authInfo = "";
  if (playground.authType === PlaygroundAuthType.BEARER_TOKEN) {
    authInfo = `,
      "headers": {
        "Authorization": "Bearer ${
          bearerToken ? bearerToken : "<YOUR_API_KEY>"
        }"
      }`;
  }
  const result = `
${oauthNote}The Gemini CLI uses the mcpServers configuration in your <strong>settings.json</strong> file to locate and connect to MCP servers.

You can configure MCP servers at the global level in the ~/.gemini/settings.json file or in your project's root directory, create or open the .gemini/settings.json file. 

Within the file, add the mcpServers configuration block.

\`\`\`json
{  
  "mcpServers": {
    "${sanitizeName(playground.name)}": {     
      "${
        playground.mcpServerType === "HTTP_STREAM" ? "httpUrl" : "url"
      }": "${mcpServerUrl}"${authInfo}
    }
  }
}
\`\`\`


For further details, see [the official documentation here](https://github.com/google-gemini/gemini-cli/blob/main/docs/tools/mcp-server.md).
`;

  return result;
};
export default getGeminiCliInstructions;
